import { Component, ViewChild, ElementRef } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ApiService } from '../../../core/services/api.service';
import { HttpParams } from '@angular/common/http';
import { ConfigAlert } from '../../../Models/config-alert';
import { MessageService } from '../../../core/services/message.service';
import { MatChipInputEvent, MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Item } from '../../../Models/item';
import { AlertType } from 'src/app/Models/alert-type';

@Component({
    selector: 'config-alert',
    templateUrl: './config-alert.component.html',
    styleUrls: ['./config-alert.component.scss']
})

export class ConfigAlertComponent {

  alertTypes: string[] = ['GENERAL.ENUMS.ALERT_TYPE.LOAD', 'GENERAL.ENUMS.ALERT_TYPE.DELIVERED_SHIP',
    'GENERAL.ENUMS.ALERT_TYPE.NEW_SCHEDULE_SHIP', 'GENERAL.ENUMS.ALERT_TYPE.NO_MERCHANDISE',
    'GENERAL.ENUMS.ALERT_TYPE.MERCHANDISE_READY', 'GENERAL.ENUMS.ALERT_TYPE.MERCHANDISE_DEVOLUTION',
    'GENERAL.ENUMS.ALERT_TYPE.SHIP_DELETED', 'GENERAL.ENUMS.ALERT_TYPE.SHIP_ORDER_CHANGE',
    'GENERAL.ENUMS.ALERT_TYPE.SHIP_DELIVEY_DATE_CHANGE'];

  selectedAlertTypes: string[] = [];

  alertTypeCtrl = new FormControl();
  selectedAuth: any;
  selectedAlertType: any;
  removable = true;
  to: string[] = [];
  cc: string[] = [];
  cco: string[] = [];
  configuration: ConfigAlert;
  alertTypeEnt: AlertType;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  filteredAlertType: Observable<string[]>;

  auths: string[] = ['GENERAL.ENUMS.AUTHORIZATION.ADMINISTRATOR', 'GENERAL.ENUMS.AUTHORIZATION.STORER',
    'GENERAL.ENUMS.AUTHORIZATION.DRIVER', 'GENERAL.ENUMS.AUTHORIZATION.HOST_CLIENT'];

  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('alertTypeInput') alertTypeInput: ElementRef<HTMLInputElement>;

  constructor(private apiService: ApiService, private messageService: MessageService) {
    this.filteredAlertType = this.alertTypeCtrl.valueChanges.pipe(
      startWith(null),
      map((auth: string | null) => auth ? this._filter(auth) : this.alertTypes.slice()))
  }

  getAlertTypes() {
    if (this.selectedAuth) {
      let auth: number = this.auths.indexOf(this.selectedAuth);
      this.getConfig(auth);
    }
  }

  getConfig(auth: number) {
    let params = new HttpParams();
    params = params.append("authorization", auth.toString());
    this.selectedAlertTypes = [];
    this.apiService.get('api/configAlert/getConfig', params).subscribe(response => {
      if (response.data) {
        this.configuration = response.data;
        this.configuration.alertTypes.forEach(item => {
          this.selectedAlertTypes.push(this.alertTypes[item]);
        });
        this.to = this.configuration.to;
        this.cc = this.configuration.cc;
        this.cco = this.configuration.cco;
      }
    });
  }

  updateConfig() {
    this.apiService.put('api/configAlert', this.configuration).subscribe((response: any) => {
      if (response.data) {
        this.messageService.success('Éxito', 'La configuración se actualizó correctamente');
      }
    });
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        if (this.configuration) {
          let repeated = false;
          if (!this.configuration.alertTypes)
            this.configuration.alertTypes = [];
          this.configuration.alertTypes.forEach(item => {
            if (item == this.alertTypes.indexOf(value.trim())) {
              repeated = true;
              return;
            }
          });
          if (!repeated) {
            this.selectedAlertTypes.push(value.trim());
            this.configuration.alertTypes.push(this.alertTypes.indexOf(value.trim()));
            this.updateConfig();
          } else {
            this.messageService.error('Error', 'El tipo de alerta ya se encuentra agregado.');
          }
        }

        
        
        if (this.configuration) {
          
        }
      }

      // Reset the input value
      if (input) {
        input.value = '';
      }

      this.alertTypeCtrl.setValue(null);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.configuration) {
      let repeated = false;
      if (!this.configuration.alertTypes)
        this.configuration.alertTypes = [];
      this.configuration.alertTypes.forEach(item => {
        if (item == this.alertTypes.indexOf(event.option.value)) {
          repeated = true;
          return;
        }
      });
      if (!repeated) {
        this.selectedAlertTypes.push(event.option.value);
        this.configuration.alertTypes.push(this.alertTypes.indexOf(event.option.value));
        this.updateConfig();
      } else {
        this.messageService.error('Error', 'El tipo de alerta ya se encuentra agregado.');
      }
    }
    this.alertTypeInput.nativeElement.value = '';
    this.alertTypeCtrl.setValue(null);
  }

  remove(alertType: string): void {
    if (this.configuration) {
      const index = this.selectedAlertTypes.indexOf(alertType);
      const indexTotal = this.alertTypes.indexOf(alertType);
      if (index >= 0) {
        this.selectedAlertTypes.splice(index, 1);
      }
      this.configuration.alertTypes.forEach((item, index) => {
        if (item == indexTotal) {
          this.configuration.alertTypes.splice(index, 1);
          return;
        }
      });
      this.updateConfig();
    }
    

    
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.alertTypes.filter(alerType => alerType.toLowerCase().indexOf(filterValue) === 0);
  }

  addTo(event: MatChipInputEvent): void {
    if (this.configuration) {
      if (!this.configuration.to)
        this.configuration.to = [];
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.to.push(value.trim());
      }
      this.configuration.to = this.to;
      this.updateConfig();
      if (input) {
        input.value = '';
      }
    }
  }

  removeTo(to: string): void {
    const index = this.to.indexOf(to);
    if (index >= 0) {
      this.to.splice(index, 1);
      this.configuration.to = this.to;
      this.updateConfig();
    }
  }

  addCC(event: MatChipInputEvent): void {
    if (this.configuration) {
      if (!this.configuration.cc)
        this.configuration.cc = [];
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.cc.push(value.trim());
      }
      this.configuration.cc = this.cc;
      this.updateConfig();
      if (input) {
        input.value = '';
      }
    }
  }

  removeCC(cc: string): void {
    const index = this.cc.indexOf(cc);
    if (index >= 0) {
      this.cc.splice(index, 1);
      this.configuration.cc = this.cc;
      this.updateConfig();
    }
  }

  addCCO(event: MatChipInputEvent): void {
    if (this.configuration) {
      if (!this.configuration.cco)
        this.configuration.cco = [];
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.cco.push(value.trim());
      }
      this.configuration.cco = this.cco;
      this.updateConfig();
      if (input) {
        input.value = '';
      }
    }
  }

  removeCCO(cco: string): void {
    const index = this.cco.indexOf(cco);
    if (index >= 0) {
      this.cco.splice(index, 1);
      this.configuration.cco = this.cco;
      this.updateConfig();
    }
  }
  getMessage(){
    let params = new HttpParams();
    let type = this.alertTypes.indexOf(this.selectedAlertType);
    params = params.append("alertType", type.toString());
    this.apiService.get('api/alertType/GetAlertType', params).subscribe(response => {
      if(response.data){
        this.alertTypeEnt = response.data;
      }
    });
  }

  saveAlertType(){
    this.apiService.put('api/alertType', this.alertTypeEnt).subscribe((response: any) => {
      if(response.data){
        this.messageService.success('USERS.MESSAGES.SUCCESS', 'CONFIG_ALERT.SUCCESS');
      }
    });
  }
}

